import { axiosInstance } from '@/utils/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { env } from '@/utils/constants/env';
import { Notifications } from '@/utils/types/notification';

export const NotificationService = {
  useGetNotification: ({
    page = 0,
    limit = 100,
    isRead,
    userId,
  }: {
    page: number;
    limit: number;
    isRead: boolean | null;
    userId: string;
  }) =>
    useQuery<Notifications>({
      queryKey: ['notifications', page, limit, isRead, userId],
      queryFn: async () => {
        const url = new URL(`${env.apiTasklistBaseUrl}/api/v1/notifications`);

        // Add parameters
        url.searchParams.append('page', page.toString());
        url.searchParams.append('limit', limit.toString());

        // Only add isRead if it has a value
        if (isRead !== undefined && isRead !== null) {
          url.searchParams.append('isRead', isRead.toString());
        }

        url.searchParams.append('userId', userId);

        const { data } = await axiosInstance.get(url.toString());

        return data.data;
      },
    }),

  fetchNotifications: async ({
    page = 0,
    limit = 100,
    isRead,
    userId,
  }: {
    page: number;
    limit: number;
    isRead: boolean | null;
    userId: string;
  }) => {
    const response = await axiosInstance.get(`${env.apiTasklistBaseUrl}/api/v1/notifications`, {
      params: {
        page,
        limit,
        isRead,
        userId,
      },
    });
    return response.data.data;
  },
};
